<template>
  <section>
    <div class="title-area">
      <h2 class="sub-title">
        {{ Ranking.all[lang] }}
      </h2>
      <!-- 更新時間 -->
      <div
        class="update-time"
        v-if="
          !isLoadingRanking &&
          !isNotFound &&
          !isServerError &&
          dataRanking.metadata.event_date_at[lang]
        "
      >
        {{ dataRanking.metadata.event_date_at[lang] }}
      </div>
    </div>
    <!-- 絞り込み -->
    <div class="narrow-down">
      <h3 class="h3-title">
        {{ Ranking.filter[lang] }}
        <span class="sub">
          {{ Ranking.multi[lang] }}
        </span>
      </h3>
      <div class="select-area">
        <!-- 性別 -->
        <dl class="narrow-down-list">
          <dt class="narrow-down-list__team">
            <label for="gender-id" class="label">
              {{ Ranking.sex[lang] }}
            </label>
          </dt>
          <dd class="narrow-down-list__description">
            <select
              id="gender-id"
              name="gender"
              v-model="selectGender"
              class="select"
            >
              <option value="" selected>
                {{ Ranking.reserve[lang] }}
              </option>
              <option value="1">
                {{ Ranking.male[lang] }}
              </option>
              <option value="2">
                {{ Ranking.female[lang] }}
              </option>
            </select>
          </dd>
        </dl>
        <!-- 年代 -->
        <dl class="narrow-down-list">
          <dt class="narrow-down-list__team">
            <label for="age-id" class="label">
              {{ Ranking.age[lang] }}
            </label>
          </dt>
          <dd class="narrow-down-list__description">
            <select id="age-id" name="age" v-model="selectAge" class="select">
              <option value="" selected>
                {{ Ranking.reserve[lang] }}
              </option>
              <option value="0,19">~19</option>
              <option value="20,24">20~24</option>
              <option value="25,29">25~29</option>
              <option value="30,34">30~34</option>
              <option value="35,39">35~39</option>
              <option value="40,44">40~44</option>
              <option value="45,49">45~49</option>
              <option value="50,54">50~54</option>
              <option value="55,59">55~59</option>
              <option value="60,64">60~64</option>
              <option value="65,69">65~69</option>
              <option value="70,74">70~74</option>
              <option value="75,79">75~79</option>
              <option value="80,120">80~</option>
            </select>
          </dd>
        </dl>
        <!-- 居住地 -->
        <dl class="narrow-down-list">
          <dt class="narrow-down-list__team">
            <label for="pref-id" class="label">
              {{ Ranking.location[lang] }}
            </label>
          </dt>
          <dd class="narrow-down-list__description">
            <label for="area-id"></label>
            <select
              id="area-id"
              class="select"
              name="area"
              v-model="selectArea"
              @change="changeSelectArea()"
            >
              <option value="" selected>
                {{ Ranking.reserve[lang] }}
              </option>
              <option
                v-for="(area, index) in dataEventSummary.areas"
                :key="index"
                :value="area.code"
              >
                {{ area.name[lang] }}
              </option>
            </select>
          </dd>
          <dd class="narrow-down-list__description" v-if="!isSelectCountry">
            <select
              id="pref-id"
              class="select"
              name="area"
              v-model="selectCountry"
              :disabled="isSelectCountry"
            >
              <option value="" selected>
                {{ Ranking.reserve[lang] }}
              </option>
              <option
                v-for="(country, index) in selectCountries()"
                :key="index"
                :value="country.code"
              >
                {{ country.name[lang] }}
              </option>
            </select>
          </dd>
        </dl>
        <button
          type="button"
          @click="emitTypeNarrowingDown"
          class="button filter flex-all-center"
        >
          <span>
            {{ Ranking.apply[lang] }}
          </span>
        </button>
        <button type="button" @click="emitRanking" class="button">
          {{ Ranking.clear[lang] }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import Ranking from "../../../assets/constants/ranking/ranking.json";

export default {
  data() {
    return {
      isSelectCountry: true,
      selectCountry: "",
      selectGender: "",
      selectAge: "",
      selectArea: "",
    };
  },
  methods: {
    /**
     * 居住地(エリア)を変更時に発火するイベント
     */
    changeSelectArea: function () {
      this.selectCountry = "";
      this.selectArea
        ? (this.isSelectCountry = false)
        : (this.isSelectCountry = true);
    },

    /**
     * 居住地(エリア)の変更が検知されたら発火するイベント
     * 値によって都道府県、または選択した国地域のリストを返却します
     */
    selectCountries: function () {
      return this.dataEventSummary.areas.find(
        (area) => area.code === this.selectArea
      ).countries;
    },

    emitTypeNarrowingDown: function () {
      this.$emit(
        "type-narrowing-down",
        this.selectGender,
        this.selectAge,
        this.selectArea,
        this.selectCountry,
        "",
        "",
        ""
      );
    },

    emitRanking: function () {
      // 絞り込み初期化
      this.selectGender = "";
      this.selectAge = "";
      this.selectArea = "";
      this.selectCountry = "";
      this.$emit("initial-ranking");
    },
  },
  props: {
    isLoadingRanking: Boolean,
    isNotFound: Boolean,
    isServerError: Boolean,
    dataRanking: Object,
    dataEventSummary: Object,
  },
  computed: {
    Ranking: function () {
      return Ranking;
    },
    lang: function () {
      return this.$store.state.lang;
    },
  },
  name: "ForeignRefinedSearch",
};
</script>

<style scoped>
.title-area {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .sub-title {
    font-size: 32px;
    font-weight: 900;
  }
}
.narrow-down {
  margin: 32px 0 0 0;
  padding: 30px 40px 33px 40px;
  background-color: #eee;
  .h3-title {
    font-size: 24px;
    .sub {
      margin: 0 0 0 15px;
      font-size: 14px;
      font-weight: normal;
    }
  }
  .select-area {
    margin: 25px 0 0 0;
    display: flex;
    .narrow-down-list {
      margin: 0 30px 0 0;
      &:last-of-type {
        margin: 0 25px 0 0;
      }
      &__team {
        line-height: 1;
        font-size: 20px;
        font-weight: bold;
      }
      &__description {
        margin: 10px 0 0 0;

        .label {
          font-size: 20px;
        }

        .select {
          padding: 0 0 0 15px;
          width: 180px;
          height: 35px;
          border: solid 1px #000;
          border-radius: 6px;
          font-size: 14px;
          background: #fff url("../../../assets/images/arrow-down.svg")
            no-repeat center right 10px;
          cursor: pointer;
        }
      }
    }
    .button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 135px;
      height: 65px;
      border: solid 1px #000;
      background-color: #fff;
      &:not(:last-of-type) {
        margin: 0 25px 0 0;
      }
      &:hover {
        color: #fff;
        background-color: #000;
      }
    }
    .filter {
      &::before {
        content: "";
        display: inline-block;
        width: 18px;
        height: 16px;
        margin: 0 4px 0 0;
        background: url("../../../assets/images/filter.svg") no-repeat center /
          18px 16px;
      }
      &:hover {
        &::before {
          background: url("../../../assets/images/filter-hover.svg") no-repeat
            center / 18px 16px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/ranking/ForeignRefinedSearch.vue